import { useGoBack } from 'hooks/useGoBack';
import React, { useCallback, useContext } from 'react';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import ModalSentErrorWithInfo from './ModalSentErrorWithInfo/ModalSentErrorWithInfo';
import { EditDishContext, IEditDishContext } from '../../editDishState/editDishContext';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		showErrorModalWithInfo,
		errorResponseData,
		typeOfModalWindow,
		fetchedRestaurants,
		fetchedSuggestedDishes,
		fetchedAdditionalDishes,
		fetchedDishModifications,
	} = useContext<IEditDishContext>(EditDishContext);
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow || errorResponseData });
	const goBack = useGoBack();

	const handleRedirect = useCallback(() => {
		goBack('/menu/dishes');
	}, [goBack]);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, []);

	const handleCloseModalWithInfo = useCallback(() => {
		showErrorModalWithInfo(null);
	}, []);

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalToConfirm
				onConsentEvent={handleRedirect}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmFieldsClearing'}
				description="cancelSaveInfo"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleRedirect}
				isVisible={typeOfModalWindow === 'success'}
				description="savedSuccessfully"
				visibleTime={500}
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSaving"
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'defaultTranslationIsEmpty'}
				description="errorDefaultTranslation"
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'comboModifierValidationError'}
				description="comboModifierShouldHaveModifierAtLeastOneSelectedRestaurant"
			/>
			<ModalSentErrorWithInfo
				onConsentEvent={handleCloseModalWithInfo}
				isVisible={!!errorResponseData}
				errorResponseData={errorResponseData}
				fetchedRestaurants={fetchedRestaurants}
				fetchedDishModifications={fetchedDishModifications}
				fetchedAdditionalDishes={fetchedAdditionalDishes}
				fetchedSuggestedDishes={fetchedSuggestedDishes}
			/>
		</div>
	);
};

export default ModalWindows;
